import { render, staticRenderFns } from "./DonutChart10.vue?vue&type=template&id=786c764a&scoped=true"
import script from "./DonutChart10.vue?vue&type=script&lang=js"
export * from "./DonutChart10.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786c764a",
  null
  
)

export default component.exports